import { Controller } from "@hotwired/stimulus"
import toastr from 'toastr';
toastr.options = {"closeButton": true, "progressBar": true, "timeOut": "10000" }

export default class extends Controller {
  static targets = []
  static values = {
    severity: {type: String, default: 'info'},
    message: String,
  }

  connect() {
    if(this.hasMessageValue) {
      switch(this.severityValue) {
        case 'error':
          toastr.error(this.messageValue);
          break;

        case 'success':
          toastr.success(this.messageValue);
          break;
        
          case 'warning':
          toastr.warning(this.messageValue);
          break;

        case 'info':
        default:
          toastr.info(this.messageValue)
      }
    }
    this.element.remove();
  }
};
